import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { igolfMappingRequest } from "API/apiConfig";
import { CourseElevationDataDetails, DrivingRangeGPSCreate, DrivingRangeGPSDetails, DrivingRangeGPSUpdate } from "API/apiRequest";
import axios from "axios";

const initialState = {
  driving_range_gps_create_status: "idle",
  driving_range_gps_details_status: "idle",
  driving_range_gps_update_status:"idle",
  course_elevation_data_details_status:"idle",
  visibleZoneList:[],
  selectedZone: {
    zone: "",
    details: [],
    type: "",
    visibleAreas: [],
    editableArea: "",
  },
  selectedGroup: "",
  mapDetails: {
    info: {},
    shapes: {
      facilityMarker: [],
      perimeter: [],
      landingAreas: [],
      hittingAreas: [],
      stalls: [],
      fairways: [],
      greens: [],
      cartPaths: [],
      bunkers: [],
      waterHazards: [],
      vegetation: [],
      treeAreas: [],
      trees: [],
      targets: [],
      markers: [],
      netting: [],
      poles: [],
    },
  },
  addedShape: { status: "idle", points: [] },
  shapeProperties: { type: "", color: "" },
  isNewRange:false
};

export const driving_range_gps_create = createAsyncThunk(
  "/drivingRangeGPSCreate",
  async ({ body, user }) => {
    let res = await igolfMappingRequest(DrivingRangeGPSCreate, body, user)
      .then((res) => res)
      .catch((error) => error);
    let resData = { data: res?.data };
    return resData;
  }
);

export const driving_range_gps_update = createAsyncThunk(
  "/drivingRangeGPSUpdate",
  async ({ body, user }) => {
    let res = await igolfMappingRequest(DrivingRangeGPSUpdate, body, user)
      .then((res) => res)
      .catch((error) => error);
    let resData = { data: res?.data };
    return resData;
  }
);
export const driving_range_gps_details = createAsyncThunk(
  "/drivingRangeGPSDetails",
  async ({ body, user }) => {
    let res = await igolfMappingRequest(DrivingRangeGPSDetails, body, user)
      .then((res) => res)
      .catch((error) => error);
    let resData = { data: res?.data };
    return resData;
  }
);


export const MapSlice = createSlice({
  name: "MapSlice",
  initialState,
  reducers: {
    selectZone: (state, action) => {
      // state.selectedZone = action?.payload;
      state.selectedZone.zone=action?.payload?.zone;
      state.selectedZone.details=action?.payload?.details;
      state.selectedZone.type=action?.payload?.type;

    },
    setVisibleZoneList: (state, action) => { 
      state.visibleZoneList=action?.payload

    },
    setVisibleArea: (state, action) => {
      state.selectedZone.visibleAreas = action?.payload;
    },
    setEditableArea: (state, action) => {
      state.selectedZone.editableArea = action?.payload;
    },
    setSelectedGroup: (state, action) => {
      state.selectedGroup = action?.payload;
    },
    setMapData: (state, action) => {
      let temp_mapDetails= {...state.mapDetails}
      temp_mapDetails.info=action?.payload?.info;
      temp_mapDetails.shapes.facilityMarker=action?.payload?.shapes?.facilityMarker || [];
      temp_mapDetails.shapes.perimeter=action?.payload?.shapes?.perimeter || [];
      temp_mapDetails.shapes.landingAreas=action?.payload?.shapes?.landingAreas || [];
      temp_mapDetails.shapes.hittingAreas=action?.payload?.shapes?.hittingAreas || [];
      temp_mapDetails.shapes.stalls=action?.payload?.shapes?.stalls || [];
      temp_mapDetails.shapes.fairways=action?.payload?.shapes?.fairways || [];
      temp_mapDetails.shapes.greens=action?.payload?.shapes?.greens || [];
      temp_mapDetails.shapes.cartPaths=action?.payload?.shapes?.cartPaths || [];
      temp_mapDetails.shapes.bunkers=action?.payload?.shapes?.bunkers || [];
      temp_mapDetails.shapes.waterHazards=action?.payload?.shapes?.waterHazards || [];
      temp_mapDetails.shapes.vegetation=action?.payload?.shapes?.vegetation || [];
      temp_mapDetails.shapes.treeAreas=action?.payload?.shapes?.treeAreas || [];
      temp_mapDetails.shapes.trees=action?.payload?.shapes?.trees || [];
      temp_mapDetails.shapes.targets=action?.payload?.shapes?.targets || [];
      temp_mapDetails.shapes.markers=action?.payload?.shapes?.markers || [];
      temp_mapDetails.shapes.netting=action?.payload?.shapes?.netting || [];
      temp_mapDetails.shapes.poles=action?.payload?.shapes?.poles || [];
    },
    setAddedShapeStatus: (state, action) => {
      state.addedShape.status = action?.payload;
      if (action?.payload === "idle") {
        state.addedShape.points = initialState.addedShape.points;
        state.shapeProperties.type = initialState.shapeProperties.type;
        state.shapeProperties.color = initialState.shapeProperties.color;
      }
    },
    setAddedShapePoints: (state, action) => {
      state.addedShape.points = action?.payload;
    },
    setShapePropertiesType: (state, action) => {
      state.shapeProperties.type = action?.payload;
    },
    setShapePropertiesColor: (state, action) => {
      state.shapeProperties.color = action?.payload;
    },
    setIsNewRange:(state, action) => {
      state.isNewRange = action?.payload;
    },
    removeAllMapData: (state) => {
      state.driving_range_status=initialState.driving_range_status;
      state.driving_range_gps_details_status=initialState.driving_range_gps_details_status;
      state.selectedZone = initialState.selectedZone;
      state.selectedGroup = initialState.selectedGroup;
      state.mapDetails = initialState.mapDetails;
      state.addedShape=initialState.addedShape;
      state.shapeProperties=initialState.shapeProperties;
      state.isNewRange=initialState.isNewRange;
      state.visibleZoneList=initialState.visibleZoneList;
    },
    resetShapeProperties: (state) => {
      state.shapeProperties = initialState.shapeProperties;
    },
  },

  extraReducers: (builder) => {
    builder
      // map data submit
      .addCase(driving_range_gps_create.pending, (state) => {
        state.driving_range_gps_create_status = "loading";
      })
      .addCase(driving_range_gps_create.fulfilled, (state, { payload }) => {
        state.driving_range_gps_create_status = "idle";
       
      })
      .addCase(driving_range_gps_create.rejected, (state) => {
        state.driving_range_gps_create_status = "idle";
      })
      // map data fetch
      .addCase(driving_range_gps_details.pending, (state) => {
        state.driving_range_gps_details_status = "loading";
      })
      .addCase(driving_range_gps_details.fulfilled, (state, { payload }) => {
        state.driving_range_gps_details_status = "idle";
        // redux is filled from the component
      })
      .addCase(driving_range_gps_details.rejected, (state) => {
        state.driving_range_gps_details_status = "idle";
      })
      .addCase(driving_range_gps_update.pending, (state) => {
        state.driving_range_gps_update_status = "loading";
      })
      .addCase(driving_range_gps_update.fulfilled, (state, { payload }) => {
        state.driving_range_gps_update_status = "idle";
      })
      .addCase(driving_range_gps_update.rejected, (state) => {
        state.driving_range_gps_update_status = "idle";
      })

      
  },
});

export const {
  selectZone,
  setVisibleArea,
  setIsNewRange,
  removeAllMapData,
  setEditableArea,
  setSelectedGroup,
  setMapData,
  setAddedShapeStatus,
  setAddedShapePoints,
  setShapePropertiesType,
  setShapePropertiesColor,
  resetShapeProperties,
  setVisibleZoneList
} = MapSlice.actions;

export default MapSlice.reducer;
